// extracted by mini-css-extract-plugin
export default {"fr-view":"Pin_fr-view__N3xUg","pin":"Pin_pin__EFVvd","load":"Pin_load__+W53n","correct":"Pin_correct__CVzlK"};